import { CellField } from '@/components/custom/erp/input-table-v2';
import { roundNumber } from '@/lib/formatUtils';
import { Label } from '@/components/ui/label';

interface BottomBarProps {
  so_luong?: number;
  thanh_tien?: number;
  thue?: number;
  tong_tien?: number;
}

function BottomBar({ so_luong = 0, thanh_tien = 0, thue = 0, tong_tien = 0 }: BottomBarProps) {
  return (
    <div className='w-full border-t bg-white px-4 py-2'>
      <div className='flex'>
        <div className='flex flex-col'>
          {/* Column 1 */}
          <div className='flex items-center'>
            <Label className='w-28 font-medium'>Tổng số lượng</Label>
            <CellField name='t_so_luong' type='number' className='w-40 border-b' value={so_luong} />
          </div>
        </div>

        <div className='ml-4 flex flex-col'>
          <div className='flex items-center'>
            <Label className='w-24 font-medium'>Tổng tiền</Label>
            <CellField name='t_tien_nt' type='number' value={roundNumber(thanh_tien, 0)} className='w-40 border-b' />
            <CellField name='t_tien' type='number' value={roundNumber(thanh_tien, 0)} className='hidden' />
          </div>
          <div className='flex items-center'>
            <Label className='w-24 font-medium'>Tổng thuế</Label>
            <CellField name='t_thue_nt' type='number' value={roundNumber(thue, 0)} className='w-40 border-b' />
            <CellField name='t_thue' type='number' value={roundNumber(thue, 0)} className='hidden' />
          </div>
        </div>

        <div className='ml-auto flex w-1/4 flex-col'>
          {/* Column 3 */}
          <div className='flex items-center'>
            <Label className='w-32 font-medium'>Tổng thanh toán</Label>
            <CellField name='t_tt_nt' type='number' value={roundNumber(tong_tien, 0)} className='w-40 border-b' />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
